import * as ImportedEscrow from "./IEscrow.json";
export const itenery = ImportedEscrow;

export const abi = ImportedEscrow.abi;

export * from "./Escrow";
